import React from 'react';

import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from 'react-table';

import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { Col, Container, Row, Spinner, Table } from 'react-bootstrap';
import './styles.scoped.css';
import { TablePagination } from '../../../components';

const columnClassName = 'align-middle text-nowrap';

const casColumns = [
  {
    Header: 'Branch',
    accessor: 'Branch',
    className: columnClassName,
  },
  {
    Header: 'LOB',
    accessor: 'LOB',
    className: columnClassName,
  },
  {
    Header: 'Job#',
    accessor: 'JOB_ID',
    className: columnClassName,
  },
  {
    Header: 'Asgn Status',
    accessor: 'ASS_STATUS',
    className: columnClassName,
  },
  {
    Header: 'Appl Last Name',
    accessor: 'Appl_Last_Name',
    className: columnClassName,
  },
  {
    Header: 'Appl First Name',
    accessor: 'Appl_First_Name',
    className: columnClassName,
  },
  {
    Header: 'Appl Middle Name',
    accessor: 'Appl_Middle_Name',
    className: columnClassName,
  },
  {
    Header: 'Position',
    accessor: 'ASS_POSITION',
    className: columnClassName,
  },
  {
    Header: 'Start Date',
    accessor: 'ASS_STARTDATE',
    className: columnClassName,
  },
  {
    Header: 'End Date',
    accessor: 'ASS_ENDDATE',
    className: columnClassName,
  },
  {
    Header: 'Client Name',
    accessor: 'CUST_NAME',
    className: columnClassName,
  },
];

function getSortedIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const CASTable = ({ data, loading }) => {
  const tableInstance = useTable(
    {
      columns: casColumns,
      data,
      initialState: {
        pageSize: 200,
        sortBy: [
          {
            id: 'CreatedAt',
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
  } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => (
      <th {...column.getHeaderProps(column.getSortByToggleProps())}>
        {column.render('Header')}
        <span>
          {column.canSort
            ? getSortedIcon(column.isSorted, column.isSortedDesc)
            : null}
        </span>
      </th>
    ));
    return <tr {...headerGroup.getHeaderGroupProps()}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => (
      <td
        {...cell.getCellProps({
          className: cell.column.className,
          style: cell.column.style,
        })}
      >
        {cell.render('Cell')}
      </td>
    ));

    return <tr {...row.getRowProps()}>{cells}</tr>;
  });

  return (
    <Container fluid>
      <Row className="align-items-center">
        <Col className="d-flex justify-content-center justify-content-md-end">
          <TablePagination tableInstance={tableInstance} />
        </Col>
      </Row>
      <Row>
        <Col className="border border-light rounded shadow-sm">
          <Table hover responsive borderless {...getTableProps()}>
            <thead className="text-nowrap">{tableHeaders}</thead>
            <tbody {...getTableBodyProps()}>{tableRows}</tbody>
          </Table>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {loading && <Spinner animation="border" />}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default CASTable;
